var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12","md":_vm.md}},[_c('v-card-subtitle',[_c('v-checkbox',{attrs:{"value":_vm.value,"label":_vm.label,"readonly":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }